import React from 'react'
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import useSkeletonTheme from '../../hooks/useSkeletonTheme'

export const NavHeaderSkeleton = () => {
    const { xs } = useSkeletonTheme();
    return (
        <SkeletonTheme color={xs.color} highlightColor={xs.highlightColor}>
            <div>
                <Skeleton className='col-3' />
            </div>
            <div>
                <Skeleton className='col-5' />
            </div>
        </SkeletonTheme>
    )
}
